<div class="hyperkit-editor-wrapper" [style.--editor-height]="editorHeight">
  <ngx-editor-menu [editor]="editor"></ngx-editor-menu>
  <ngx-editor
    [editor]="editor"
    [(ngModel)]="html"
    (ngModelChange)="onEditorChange($event)"
    (focusIn)="onFocusIn()"
    (focusOut)="onFocusOut()"
    [placeholder]="'Enter text here...'"
  ></ngx-editor>
</div>
